/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Invite_CreatedInputs */

const en_invite_created = /** @type {(inputs: Invite_CreatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Send this link. It works once, until ${i?.date}.`)
};

const de_invite_created = /** @type {(inputs: Invite_CreatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Schick diesen Link. Er funktioniert einmal, bis zum ${i?.date}.`)
};

/**
* | output |
* | --- |
* | "Send this link. It works once, until {date}." |
*
* @param {Invite_CreatedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const invite_created = /** @type {((inputs: Invite_CreatedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_CreatedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_invite_created(inputs)
	return en_invite_created(inputs)
});